// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"64ddf26d","239":"a21b4181","447":"650fd7f4","455":"4c6fb4c6","762":"9be6c303","967":"10891215"}[chunkId] + ".chunk.js";
};